import { LOAD_TAC, ACCEPT_TAC, LOGOUT } from '../../store/actions';
import { component, action, getter } from '../../decorators';

@component
export default class TaC {
   text = ''

   @action(ACCEPT_TAC) accept
   @action(LOGOUT) decline
   @action(LOAD_TAC) load
   @getter() getTacText

   created() {
      this.load();
   }
}
